import { Phone } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { telHref, waHref } from "@/lib/contact";
import { WhatsAppIcon } from "@/components/brand/WhatsAppIcon";

export const AnnouncementBar = () => {
  const { settings } = useSite();
  if (!settings.announcement_enabled || !settings.announcement_text) return null;
  return (
    <div className="bg-brand-navy px-4 py-2 text-center text-sm font-medium text-white" data-testid="announcement-bar" role="note">
      {settings.announcement_text}
    </div>
  );
};

export const MobileContactBar = () => {
  const { settings } = useSite();
  return (
    <div
      className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-2 gap-2 border-t border-slate-200 bg-white/95 p-2 backdrop-blur-md md:hidden"
      style={{ paddingBottom: "max(0.5rem, env(safe-area-inset-bottom))" }}
      data-testid="mobile-contact-bar"
    >
      <a href={telHref(settings)} data-testid="mobile-bar-call-btn" className="flex h-12 items-center justify-center gap-2 rounded-full bg-brand-blue text-base font-semibold text-white active:scale-[0.98]">
        <Phone className="h-4 w-4" aria-hidden="true" /> Call
      </a>
      <a href={waHref(settings)} target="_blank" rel="noopener noreferrer" data-testid="mobile-bar-whatsapp-btn" className="flex h-12 items-center justify-center gap-2 rounded-full bg-brand-wa text-base font-semibold text-white active:scale-[0.98]">
        <WhatsAppIcon className="h-5 w-5" /> WhatsApp
      </a>
    </div>
  );
};

export const FloatingWhatsApp = () => {
  const { settings } = useSite();
  return (
    <a
      href={waHref(settings)}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-btn"
      aria-label="Chat with Young Spine Tricity on WhatsApp"
      className="group fixed bottom-6 right-6 z-40 hidden h-14 items-center gap-2 rounded-full bg-brand-wa px-4 text-white shadow-lg shadow-brand-wa/30 transition-[background-color,transform] hover:-translate-y-0.5 hover:bg-brand-waDark md:flex"
    >
      <WhatsAppIcon className="h-6 w-6" />
      <span className="text-sm font-semibold">WhatsApp us</span>
    </a>
  );
};
